"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsTypes = exports.Results = void 0;
var _lodash = require("lodash");
var _simpleSearchQueryField = require("../simple-search-query-field");
var _testing = require("../../utils/testing");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ResultsTypes = exports.ResultsTypes = ['MAP', 'LIST'];
var parseResults = result => {
  if (!result) {
    return null;
  }
  var type = ResultsTypes.find(resultType => {
    var _result$type;
    return ((_result$type = result.type) === null || _result$type === void 0 ? void 0 : _result$type.toUpperCase()) === resultType;
  });
  var clusters = Number(result.clusters);
  return _objectSpread({
    type: type || 'LIST'
  }, clusters ? {
    clusters
  } : {});
};
class Results extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, input) {
    var value = Results.isInstance(input) ? input.value : parseResults(input);
    super(searchOptions, value, {
      type: 'LIST'
    });
    _defineProperty(this, "urlSlug", Results.urlSlug);
  }
  isMapSearch() {
    var _this$value;
    return ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.type) === 'MAP';
  }
  isListSearch() {
    var _this$value2;
    return ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.type) === 'LIST';
  }
  getUrlParameterValue() {
    return this.isMapSearch() ? 'map' : null;
  }
  isDefault() {
    return (0, _lodash.isEqual)(this.value, this.default);
  }
  isResults() {
    return true;
  }
  static isInstance(obj) {
    return (0, _testing.isA)(obj, 'Results');
  }
  static fromUrlParameters(searchOptions, q) {
    var urlValue = q[Results.urlSlug];
    return new Results(searchOptions, typeof urlValue === 'string' ? {
      type: urlValue
    } : null);
  }
}
exports.Results = Results;
_defineProperty(Results, "urlSlug", 'view');